import DOMPurify from 'dompurify'

import { removeHtmlFromString } from './removeHtmlFromString'

export function sanitizeHtmlContent(value?: string | null): string {
  if (!value?.trim()) {
    return ''
  }

  if (typeof DOMPurify.sanitize !== 'function') {
    return ''
  }

  return DOMPurify.sanitize(value)
}

export function extractPlainTextFromHtml(value?: string | null): string {
  if (!value) {
    return ''
  }

  return removeHtmlFromString(value).trim()
}

export function sanitizeTextContent(value?: string | null): string {
  return extractPlainTextFromHtml(sanitizeHtmlContent(value))
}
